import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { media } from '../../theme/breakpoints'

const Button = styled.button`
    --width: 250px;
    --height: 40px;
    --horizontal-padding: 20px;
    --font-size: 16px;

    display: flex;
    align-items: center;
    border-radius: calc(var(--height) / 2);
    font-size: var(--font-size);
    width: var(--width);
    height: var(--height);
    padding-left: var(--horizontal-padding);
    padding-right: var(--horizontal-padding);
    border: ${(p) => `1px solid ${p.theme.colors.lighterGrey}`};
    cursor: pointer;
    background-color: white;

    &:hover {
        color: white;
        background-color: ${(p) => p.theme.colors.primaryGreen};
    }

    ${media.tabletAndBelow} {
        min-height: 44px;
    }
`

const Text = styled.span`
    margin-left: 10px;
`

interface Props {
    icon: ReactNode
    text: string
    onClick: () => void
}

export const SignInButton: FC<Props> = ({ icon, text, onClick }) => {
    return (
        <Button onClick={onClick}>
            {icon}
            <Text>{text}</Text>
        </Button>
    )
}
